import { render, staticRenderFns } from "./ObjectFields.vue?vue&type=template&id=2392d5dc&"
import script from "./ObjectFields.vue?vue&type=script&lang=js&"
export * from "./ObjectFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports